export default {
  categoryLabel: {
    id: 'report_illicit_content_category_label',
    defaultMessage: 'What would you like to report?',
  },

  categoryOptionIllegalContentShort: {
    id: 'report_illicit_content_category_option_illegal_content_short',
    defaultMessage: 'Illegal content',
  },

  categoryOptionIllegalContentFull: {
    id: 'report_illicit_content_category_option_illegal_content_full',
    defaultMessage: 'Illegal content (hateful, discriminatory, violent)',
  },

  categoryOptionCounterfeitShort: {
    id: 'report_illicit_content_category_option_counterfeit_short',
    defaultMessage: 'Counterfeit product',
  },

  categoryOptionCounterfeitFull: {
    id: 'report_illicit_content_category_option_counterfeit_full',
    defaultMessage:
      'Counterfeit product or product infringing intellectual property rights',
  },

  categoryOptionMisleadingAdvertisingShort: {
    id: 'report_illicit_content_category_option_misleading_advertising_short',
    defaultMessage: 'Misleading advertising',
  },

  categoryOptionMisleadingAdvertisingFull: {
    id: 'report_illicit_content_category_option_misleading_advertising_full',
    defaultMessage: 'Misleading advertising or commercial practice',
  },

  categoryOptionDangerousProductShort: {
    id: 'report_illicit_content_category_option_dangerous_product_short',
    defaultMessage: 'Dangerous product',
  },

  categoryOptionDangerousProductFull: {
    id: 'report_illicit_content_category_option_dangerous_product_full',
    defaultMessage: 'Dangerous product or product posing a safety risk',
  },

  categoryOptionRecalledOrProhibitedShort: {
    id: 'report_illicit_content_category_option_recalled_or_prohibited_short',
    defaultMessage: 'Recalled or prohibited product',
  },

  categoryOptionRecalledOrProhibitedFull: {
    id: 'report_illicit_content_category_option_recalled_or_prohibited_full',
    defaultMessage: 'Recalled or prohibited product',
  },

  riskNatureLabel: {
    id: 'report_illicit_content_risk_nature_label',
    defaultMessage: 'Nature of the risk',
  },

  hasCausedIncidentLabel: {
    id: 'report_illicit_content_has_caused_incident_label',
    defaultMessage: 'Has the product caused an incident?',
  },

  isSubjectToRecallLabel: {
    id: 'report_illicit_content_is_subject_to_recall_label',
    defaultMessage:
      'Is the product already subject to a recall or a Safety Gate alert?',
  },

  descriptionLabel: {
    id: 'report_illicit_content_description_label',
    defaultMessage: 'Description',
  },

  descriptionHelper: {
    id: 'report_illicit_content_description_helper',
    defaultMessage:
      'Please add any useful information that will allow us to review your request. If your report concerns an intellectual property right, please specify the right invoked, its registration number, and the country in which this right is protected. The right invoked must be valid in the country for which you are requesting action.',
  },

  contentUrlLabel: {
    id: 'report_illicit_content_content_url_label',
    defaultMessage: 'Related URL',
  },

  contentUrlHelper: {
    id: 'report_illicit_content_content_url_helper',
    defaultMessage: 'Please add the URL related to the content to be reported',
  },
  evidenceLabel: {
    id: 'report_illicit_content_evidence_label',
    defaultMessage: 'Add supporting files (optional)',
  },
  evidenceDescription: {
    id: 'report_illicit_content_evidence_description',
    defaultMessage: 'Up to 5 files, 10 MB each. PDF, JPG, PNG, WebP or HEIC.',
  },
  evidenceTooMany: {
    id: 'report_illicit_content_evidence_too_many',
    defaultMessage: 'Select no more than 5 files and try again.',
  },
  evidenceTooLarge: {
    id: 'report_illicit_content_evidence_too_large',
    defaultMessage: 'Choose files smaller than 10 MB and try again.',
  },
  evidenceWrongFormat: {
    id: 'report_illicit_content_evidence_wrong_format',
    defaultMessage: 'Choose PDF, JPG, PNG, WebP or HEIC files and try again.',
  },
}
